module.exports = __webpack_public_path__ + "static/media/Congo Kinshasa.9ab44518.png";